import { useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import MeaButton from "../../../components/MeaButton";
import ContractsListComponent from "../../registrations/contracts/components/ContractsListComponent";

const SecretariatPaymentsDetailPage = () => {
  const listRef = useRef();
    const navigate = useNavigate();
  const location = useLocation();
  const { schoolId, trainingId } = useParams();

  const buildContractLink = (contract) =>
    `/school/${schoolId}/secretariat/payments/${trainingId}/contracts/${contract.id}`;

  const handlePrintAllContracts = () => {
    navigate(`/school/${schoolId}/secretariat/payments/${trainingId}/print-all-contracts${location.search}`);
  };

  const customActions = (
    <div className="flex gap-2">
      <MeaButton
        icon="pi pi-print"
        label="Imprimer"
        onClick={handlePrintAllContracts}
      />
    </div>
  );

  return (
    <MeaPage
      title="Gestion de paiements"
      subtitle="Consulter et suivre les contrats de cette formation"
      breadcrumb={<SecretariatWorkspaceBar section="payments" />}
      showBackButton={true}
      onBackButtonClick={() => navigate(`/school/${schoolId}/secretariat`)}
      customActions={customActions}
    >
      <ContractsListComponent
        ref={listRef}
        schoolId={schoolId}
        trainingId={trainingId}
        showAddButton={false}
        showToolbar={true}
        getContractLink={buildContractLink}
      />
    </MeaPage>
  );
};

export default SecretariatPaymentsDetailPage;

